import { forwardRef } from 'react'

import * as SliderPrimitive from '@radix-ui/react-slider'

import { classNames } from '@/utils/helpers.ts'

export const SliderThumb = forwardRef<
  React.ElementRef<typeof SliderPrimitive.Thumb>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Thumb> & {
    value: number | string
  }
>((props, ref) => (
  <SliderPrimitive.Thumb
    ref={ref}
    className={classNames(
      'border-primary-500 ring-offset-background relative block h-6 w-6 rounded-full border-4 bg-white transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
      props.className,
    )}
    {...props}
  >
    <div className="bg-secondary-500 absolute -top-[calc(100%+16px)] left-1/2 -translate-x-1/2 rounded px-2 py-[2px] text-xs font-medium leading-5 text-white">
      {props.value}
    </div>
  </SliderPrimitive.Thumb>
))
SliderThumb.displayName = SliderPrimitive.Thumb.displayName
